<template>
    <div class="row">
        <div class="col" v-if="isLoading">
            <card>
                 <span slot="header">
                  </span>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                 spin></font-awesome-icon></span></h1>
                <div slot="footer">
                </div>
            </card>
        </div>
        <div class="col" v-if="!isLoading && systemrecordings.length === 0">
            <card class="text-center">
                 <span slot="header">
                  </span>
                <h1 class="text-center">You currently do not have any Recording's saved!</h1>
                <base-button type="default" @click="showCreateModal = true" v-if="!isLoading"
                >Add Recording
                </base-button>
                <div slot="footer">
                </div>
            </card>
        </div>

        <system-recording-card v-if="!isLoading && systemrecordings.length > 0"
                               v-for="systemrecording in systemrecordings"
                               v-bind:key="systemrecording.id" :initial-system-recording="systemrecording"
                               v-on:saved="loadSystemRecording"
                               v-on:removed="loadSystemRecording"></system-recording-card>


    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";
    import SystemRecordingCard from "./SystemRecordingCard";

    export default {
        name: "SystemRecordingGrid",
        components: {
            SystemRecordingCard,
        },
        computed: {
            ...mapFields(`systemrecording`, ['systemrecordings']),
        },
        data() {
            return {
                isLoading: false,
                inputVisible: false,
                inputValue: [],
                dirty: [],
                saving: [],
                removing: [],
                names: [],
            };
        },
        methods: {
            created() {
                this.loadSystemRecording();
            },
            loadSystemRecording() {
                this.isLoading = true;
                this.$store.dispatch('systemrecording/loadSystemRecording').then(() => {
                    this.isLoading = false;
                })
            },

        },
        mounted() {

            if (this.$store.getters['systemrecording/needUpdate']) {
                this.loadSystemRecording();
            }

        },
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
